// Modal nhập lý do từ chối bài đăng user — bắt buộc nhập trước khi xác nhận
// (BE trả 400 nếu reason rỗng, chặn sớm ở FE để UX tốt hơn).
import React, { useEffect, useState } from "react";
import { Modal, Input, message } from "antd";

export default function CommunityRejectReasonModal({ open, onClose, onSubmit }) {
    const [reason, setReason] = useState("");
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (open) setReason("");
    }, [open]);

    const handleOk = async () => {
        const trimmed = reason.trim();
        if (!trimmed) {
            message.error("Vui lòng nhập lý do từ chối");
            return;
        }
        try {
            setSubmitting(true);
            await onSubmit(trimmed);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Modal
            title="Từ chối bài đăng"
            open={open}
            onCancel={onClose}
            onOk={handleOk}
            okText="Từ chối"
            cancelText="Hủy"
            okButtonProps={{ danger: true }}
            confirmLoading={submitting}
            destroyOnClose
        >
            <Input.TextArea
                rows={3}
                maxLength={255}
                showCount
                placeholder="Nhập lý do từ chối để người dùng biết (bắt buộc)..."
                value={reason}
                onChange={(e) => setReason(e.target.value)}
            />
        </Modal>
    );
}
